<template>
  <div class="root-card">
    <BlockContainer class="report-dashboard-card px-4 py-4">
      <div class="d-flex align-items-center mb-4">
        <div>
          <i class="h4" :class="iconClass" />
        </div>
        <h5 class="ml-4">{{ heading }}</h5>
      </div>
      <div
        :class="{
          content: true,
          fullwidth: fullWidthContent,
        }"
      >
        <slot></slot>
        <div v-if="loading || showMessage" class="overlay">
          <div v-if="showMessage">
            {{ message }}
          </div>
          <span v-else-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        </div>
      </div>
    </BlockContainer>
  </div>
</template>

<script>
import BlockContainer from '@/components/BlockContainer';

export default {
  name: 'DashboardCard',

  props: {
    heading: String,
    iconClass: String,
    loading: Boolean,
    message: String,
    showMessage: Boolean,
    fullWidthContent: Boolean,
  },

  components: {
    BlockContainer,
  },
};
</script>

<style scoped lang="scss">
.root-card {
  display: flex;
  align-content: stretch;
}

.report-dashboard-card {
  display: flex;
  flex-direction: column;
  align-content: space-between;
  overflow: hidden;
  width: 100%;

  > .heading {
    font-weight: bold;
  }

  h5 {
    margin-bottom: 0;
  }

  > .content {
    position: relative;
    flex: 1 0 auto;
    display: grid;
    align-items: center;

    &.fullwidth {
      margin: -1rem;
    }
  }
}

.overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
